// extracted by mini-css-extract-plugin
export default {"value":"SaftyFactorsSection_value__ozDzc","wrapper":"SaftyFactorsSection_wrapper__HyHA+"};